import React from "react";
import product1png from "../../../assets/images/product-1.png";
import avatar1png from "../../../assets/images/avatar-1.png";
import bgheader3png from "../../../assets/images/bg-header-3.png";
import product5smpng from "../../../assets/images/product-5-sm.png";

import { Link } from "react-router-dom";

function Product(props) {
  return (
    <>
      <header className="dx-header dx-box-5">
        <div className="bg-image bg-image-parallax">
          <img src={bgheader3png} className="jarallax-img" alt="" />
          <div style={{ backgroundColor: "rgba(27, 27, 27, .8)" }}></div>
        </div>
        <div className="container mnb-8">
          <h1 className="h4 mb-10 text-white text-center">
            Quantial – Moving Upon Signs Moveth Lesser
          </h1>

          <ul className="dx-breadcrumbs text-center">
            <li>
              <Link href="index">Home</Link>
            </li>
            <li>
              <Link href="store">Store</Link>
            </li>
            <li>Quantial – Moving Upon Signs Moveth Lesser</li>
          </ul>
        </div>
      </header>
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-gallery p-10">
                  <Link data-fancybox="images" className="dx-gallery-item">
                    <span className="dx-gallery-item-overlay">
                      <span className="icon pe-7s-exapnd2"></span>
                    </span>
                    <img src={product1png} className="dx-img" alt="" />
                  </Link>

                  <div
                    className="swiper-container dx-slider dx-slider-gallery mt-10"
                    data-swiper-speed="800"
                    data-swiper-space="10"
                    data-swiper-slides="4"
                    data-swiper-pagination-scrollbar="true"
                  >
                    <div className="swiper-scrollbar"></div>
                  </div>
                </div>
                <div className="dx-box-content pt-20 pb-0 d-md-block d-lg-none">
                  <div className="row vertical-gap xs-gap justify-content-between">
                    <div className="col col-sm-5 col-md-4">
                      <Link
                        to="/checkout"
                        className="dx-btn dx-btn-lg dx-btn-block"
                      >
                        Buy Now $49
                      </Link>
                    </div>
                    <div className="col col-sm-5 col-md-4">
                      <Link
                        to="/product"
                        className="dx-btn dx-btn-lg dx-btn-dark dx-btn-block"
                      >
                        Live Preview
                      </Link>
                    </div>
                  </div>
                </div>
                <ul className="nav dx-tab mt-35" role="tablist">
                  <li>
                    <Link
                      className="active"
                      id="description-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="description"
                      aria-selected="true"
                    >
                      Description
                    </Link>
                  </li>
                  <li>
                    <Link
                      id="changelog-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="changelog"
                      aria-selected="false"
                    >
                      Changelog
                    </Link>
                  </li>
                  <li>
                    <Link href="documentation.html">
                      Documentation{" "}
                      <span className="icon fas fa-external-link-alt"></span>
                    </Link>
                  </li>
                  <li>
                    <Link href="articles.html">
                      Knowledge Base{" "}
                      <span className="icon fas fa-external-link-alt"></span>
                    </Link>
                  </li>
                </ul>
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box">
                    <div className="tab-content dx-tab-content">
                      <div
                        className="tab-pane fade show active"
                        id="description"
                        role="tabpanel"
                        aria-labelledby="description-tab"
                      >
                        <p className="mnt-5 mb-40">
                          One after fowl own let over replenish spirit. Created
                          together tree you're given creeping. Image gathered
                          they're meat whose i us rule fish Morning you're
                          wherein. Brought without Image darkness fifth isn't
                          signs may. Divide cattle forth hath living.
                        </p>
                        <img
                          src="assets/images/product-2.png"
                          alt=""
                          className="dx-img mb-50"
                        />

                        <h3 className="h5">Features List</h3>
                        <ul className="dx-blog-post-list mnb-8">
                          <li>Fish he moveth of.</li>
                          <li>Forth life. Had give.</li>
                          <li>Cattle. Two and second.</li>
                          <li>Good make his.</li>
                          <li>Our deep great good.</li>
                          <li>I you're Meat. Fourth a.</li>
                        </ul>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="changelog"
                        role="tabpanel"
                        aria-labelledby="changelog-tab"
                      >
                        <div className="dx-changelog mt-4">
                          <div className="h5">Ver 1.1.0 - 9 Oct 2018</div>
                          <ul>
                            <li className="dx-changelog-fix">
                              <span className="dx-changelog-badge">Fix</span>
                              Divided living signs, our wherein cattle. Air
                              moving herb
                            </li>
                            <li className="dx-changelog-add">
                              <span className="dx-changelog-badge">Add</span>
                              Bring can't You'll fourth forth forth. Fowl man
                              earth
                            </li>
                            <li className="dx-changelog-add">
                              <span className="dx-changelog-badge">Add</span>
                              Make over whales forth third living creeping all
                              greater god
                            </li>
                            <li className="dx-changelog-imp">
                              <span className="dx-changelog-badge">Imp</span>So
                              isn't after divide fly to
                            </li>
                            <li className="dx-changelog-del">
                              <span className="dx-changelog-badge">Del</span>
                              She'd. Their green greater very face seas were
                              years let
                            </li>
                          </ul>
                        </div>
                        <div className="dx-changelog">
                          <div className="h5">Ver 1.0.1 - 17 Sep 2018</div>
                          <ul>
                            <li className="dx-changelog-fix">
                              <span className="dx-changelog-badge">Fix</span>I
                              every years his fill spirit. You. Days his deep
                            </li>
                          </ul>
                        </div>
                        <div className="dx-changelog">
                          <div className="h5">Ver 1.0.0 - 11 Sep 2018</div>
                          <ul>
                            <li className="dx-changelog-up">
                              <span className="dx-changelog-badge">Up</span>
                              Fifth years air thing second day Fruit so give
                              give
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <ul className="dx-blog-post-info mnt-15 mnb-1">
                      <li>Date: 11 Sep 2018</li>
                      <li>Views: 163</li>
                    </ul>
                    <ul className="dx-social-links dx-social-links-style-2 mt-15">
                      <li>
                        <Link to="/#" className="dx-social-twitter">
                          <span className="icon fab fa-twitter"></span> Twitter
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-facebook">
                          <span className="icon fab fa-facebook"></span>{" "}
                          Facebook
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-google">
                          <span className="icon fab fa-google"></span> Google
                        </Link>
                      </li>
                      <li>
                        <Link to="/#" className="dx-social-pinterest">
                          <span className="icon fab fa-pinterest"></span>{" "}
                          Pinterest
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="dx-box mt-55">
                <h2 className="h4 mb-45">Comments:</h2>

                <div className="dx-comment">
                  <div>
                    <div className="dx-comment-img">
                      <img src={avatar1png} alt="" />
                    </div>
                    <div className="dx-comment-cont">
                      <Link to="/#" className="dx-comment-name">
                        John Leonard
                      </Link>
                      <Link to="/#" className="dx-comment-reply">
                        Reply
                      </Link>
                      <div className="dx-comment-text">
                        <p className="mb-0">
                          Nullam ac dui et purus malesuada gravida id fermentum
                          orci. In eu ipsum quis urna hendrerit condimentum
                          vitae a mauris. In congue turpis purus, vitae tempus
                          ante id. Donec orci arcu, sagittis ut finibus vitae.
                        </p>
                      </div>
                      <div className="dx-comment-date">12 Feb 2018 7:40 pm</div>
                    </div>
                  </div>
                  <div className="dx-comment">
                    <div>
                      <div className="dx-comment-img">
                        <img src={avatar1png} alt="" />
                      </div>
                      <div className="dx-comment-cont">
                        <Link to="/#" className="dx-comment-name">
                          Mercy Shields
                        </Link>
                        <Link to="/#" className="dx-comment-reply">
                          Reply
                        </Link>
                        <div className="dx-comment-text">
                          <p className="mb-0">
                            In at nunc sodales lorem blandit egestas.
                            Suspendisse molestie fringilla purus, eget sagittis
                            nunc ornare sit amet. Praesent vitae ligula eu massa
                            rutrum hendrerit non facilisis nulla interdum ut.
                          </p>
                        </div>
                        <div className="dx-comment-date">
                          14 Feb 2018 8:29 am
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dx-comment">
                  <div>
                    <div className="dx-comment-img">
                      <img src={avatar1png} alt="" />
                    </div>
                    <div className="dx-comment-cont">
                      <Link to="#" className="dx-comment-name">
                        Maria Anthony
                      </Link>
                      <Link to="#" className="dx-comment-reply">
                        Reply
                      </Link>
                      <div className="dx-comment-text">
                        <p className="mb-0">
                          Donec libero sapien, dapibus id blandit sit amet,
                          iaculis sed ligula. Morbi cursus maximus elementum.
                          Phasellus viverra lacinia sapien sagittis tristique.
                        </p>
                      </div>
                      <div className="dx-comment-date">18 Feb 2018 7:13 pm</div>
                    </div>
                  </div>
                </div>

                <form action="#" className="dx-form mt-50">
                  <div className="row vertical-gap">
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-style-3"
                        type="text"
                        placeholder="Name"
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-style-3"
                        type="text"
                        placeholder="Name"
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control form-control-style-3"
                        name="name"
                        rows="8"
                        cols="80"
                        placeholder="Comment..."
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        name="button"
                        className="dx-btn dx-btn-lg"
                      >
                        Post a comment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="dx-sticky dx-sidebar">
                <div className="d-none d-lg-block mb-40">
                  <div className="row vertical-gap xs-gap justify-content-between">
                    <div className="col">
                      <Link
                        to="/checkout"
                        className="dx-btn dx-btn-lg dx-btn-block"
                      >
                        Buy Now $49
                      </Link>
                    </div>
                    <div className="col">
                      <Link
                        to="/product"
                        className="dx-btn dx-btn-lg dx-btn-dark dx-btn-block"
                      >
                        Live Preview
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Detail Information</div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">Created</div>
                    <span>11 February 2018</span>
                  </div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">Licenses</div>
                    <span>Standard,</span> <span>Extended</span>
                  </div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">
                      File Types
                    </div>
                    <span>PHP Files,</span> <span>CSS Files,</span>{" "}
                    <span>JS Files</span>
                  </div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">
                      Compatible With
                    </div>
                    <span>WPML,</span> <span>Visual Composer 4.12.x</span>
                  </div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">
                      Software Version
                    </div>
                    <span>WordPress 4.7.x,</span>
                    <span>WordPress 4.6.1,</span>
                    <span>WordPress 4.6,</span>
                    <span>WordPress 4.5.x,</span>
                    <span>WordPress 4.5.2,</span>
                    <span>WordPress 4.5.1,</span>
                    <span>WordPress 4.5</span>
                  </div>
                  <div className="dx-widget-information">
                    <div className="dx-widget-information-title">Features</div>
                    <span>Responsive,</span> <span>Well Documented,</span>{" "}
                    <span>Widget Ready</span>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Related Products</div>
                  <Link to="/product" className="dx-widget-products">
                    <span className="dx-widget-products-img">
                      <img src={product5smpng} alt="" />
                    </span>
                    <span className="dx-widget-products-text">
                      <span className="dx-widget-products-title">
                        Sensific – Saying Beast Lesser for in Fruitful
                      </span>
                      <span className="dx-widget-products-price">$59</span>
                    </span>
                  </Link>
                  <Link to="/product" className="dx-widget-products">
                    <span className="dx-widget-products-img">
                      <img src={product5smpng} alt="" />
                    </span>
                    <span className="dx-widget-products-text">
                      <span className="dx-widget-products-title">
                        Minist – Subdue Above for Signs Dry is Have Great
                      </span>
                      <span className="dx-widget-products-price">$39</span>
                    </span>
                  </Link>
                  <Link to="/product" className="dx-widget-products">
                    <span className="dx-widget-products-img">
                      <img src={product5smpng} alt="" />
                    </span>
                    <span className="dx-widget-products-text">
                      <span className="dx-widget-products-title">
                        Desty – She'd Under Light Over Multiply Stars Winged
                      </span>
                      <span className="dx-widget-products-price">$99</span>
                    </span>
                  </Link>
                  <Link href="/product" className="dx-widget-products">
                    <span className="dx-widget-products-img">
                      <img src={product5smpng} alt="" />
                    </span>
                    <span className="dx-widget-products-text">
                      <span className="dx-widget-products-title">
                        Silies – Grass Living Fly Subdue After Fruitful
                      </span>
                      <span className="dx-widget-products-price">$99</span>
                    </span>
                  </Link>
                  <Link to="/product" className="dx-widget-products">
                    <span className="dx-widget-products-img">
                      <img src={product5smpng} alt="" />
                    </span>
                    <span className="dx-widget-products-text">
                      <span className="dx-widget-products-title">
                        Interra – Evening Were Set Beginning Image That One
                      </span>
                      <span className="dx-widget-products-price">$59</span>
                    </span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Subscribe to Newsletter</div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Product;
